







import Vue from "vue";
import CommonHeader from "@/views/mobile/CommonHeader.vue";
import CommonFooter from "@/views/mobile/CommonFooter.vue";
import Home from "@/views/mobile/Home.vue";

export default Vue.extend({
  name: "App.mobile",
  components: {
    CommonHeader,
    CommonFooter,
    Home
  }
});
